import React from "react";
import { motion } from "framer-motion";
import { useSiteContent, resolveImage } from "@/context/SiteContentContext";

export default function Testimonials() {
  const content = useSiteContent();
  const t = content?.testimonials;
  if (!t) return null;

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 lg:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-12 bg-orange-600" />
              <span className="text-xs tracking-[0.25em] uppercase text-slate-500 font-display">
                {content?.sections?.testimonials_label || "Testimonials"}
              </span>
            </div>
            <h2 className="font-serif-sc text-4xl lg:text-5xl xl:text-6xl font-bold text-slate-900 leading-tight tracking-tight">
              {t.heading_top}<br />
              <span className="text-orange-600">{t.heading_bottom}</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12">
          {t.items?.map((item, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative"
            >
              <div className="font-serif-sc text-7xl text-orange-600/30 leading-none">"</div>
              <blockquote className="font-serif-sc text-lg lg:text-xl text-slate-800 leading-relaxed -mt-6">
                {item.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-slate-200">
                {item.avatar ? (
                  <img
                    src={resolveImage(item.avatar)}
                    alt={item.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-slate-200" />
                )}
                <div>
                  <div className="font-medium text-slate-900">{item.name}</div>
                  <div className="text-xs text-slate-500 tracking-wide mt-0.5">{item.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
